import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../styles/components/success-modal.css";

export const SuccessModal = ({ isOpen, title, message }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="success-modal-overlay">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: "spring", damping: 20, stiffness: 300 }}
          className="success-modal-content"
        >
          <div className="success-checkmark-wrapper">
            <svg className="success-checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" style={{ width: '80px', height: '80px' }}>
              <circle className="success-checkmark-circle" cx="26" cy="26" r="25" fill="none" />
              <path className="success-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
          </div>
          
          <h2 className="success-modal-title">{title}</h2>
          <p className="success-modal-message">{message}</p>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};
